import {
  ClubCustomerSubscription,
  CustomerQuery,
  Maybe,
  Membership,
} from "@common-vendors/generated/graphql";

type NonNullableCustomerQuery = NonNullable<CustomerQuery["customer"]>;
type NonNullableCustomerMembership = NonNullable<
  NonNullableCustomerQuery["membership"]
>;

type BuildMockCustomerParams = {
  isLoggedIn?: boolean;
  onePass: {
    club?: Partial<NonNullableCustomerQuery["club"]>;
    membership?: Maybe<
      Partial<Omit<NonNullableCustomerMembership, "subscription">> & {
        subscription?: Partial<NonNullableCustomerMembership["subscription"]>;
      }
    >;
  };
};

const defaultCustomerParams: BuildMockCustomerParams = {
  isLoggedIn: true,
  onePass: {
    club: {
      active: false,
      freeTrialEligible: true,
      onFreeTrial: false,
    },
    membership: {
      id: "1",
      linked: true,
      doubleSubscription: false,
      eligibleForMigration: false,
      subscription: {
        active: false,
        activeDaysRemaining: 20,
        autoRenewing: true,
        interval: "MONTHLY",
        latestMembershipPeriodEnd: "2023-06-05T23:59:59.000Z",
        freeTrialEligible: false,
        freeTrialDaysRemaining: 30,
        onFreeTrial: false,
        purchasePrice: 400,
        isTeamMember: false,
      },
    },
  },
};

export const buildMockCustomer = ({
  isLoggedIn = true,
  onePass: { club, membership },
}: BuildMockCustomerParams = defaultCustomerParams): CustomerQuery["customer"] => {
  if (!isLoggedIn) {
    return null;
  }
  return {
    __typename: "Customer" as const,
    id: "1234",
    displayName: "Joe",
    email: "joe@catch.com.au",
    club:
      club !== null
        ? ({
            __typename: "ClubCustomerSubscription" as const,
            ...defaultCustomerParams.onePass.club,
            ...club,
          } as ClubCustomerSubscription)
        : null,
    membership:
      membership !== null
        ? ({
            ...defaultCustomerParams.onePass.membership,
            ...membership,
            subscription: {
              ...defaultCustomerParams.onePass.membership!.subscription,
              ...membership!.subscription,
            },
          } as Membership)
        : null,
    storeCredit: {
      credit: {
        amount: 20,
      },
      expiry: "2024-05-18T13:59:59.000Z",
    },
    metaData: {
      customerUuid: "e2e51708-588c-41da-8e2a-b8b2de8ac62e",
    },
  };
};

export const mockCustomer = buildMockCustomer();
